module.exports = __webpack_public_path__ + "img/partners42.422ac7de.svg";